import { PostValuesFn } from './types'

/**
 * @desc filters out keys starting with "_"
 */
export const postValues: PostValuesFn = (values) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
  Object.keys(values).reduce((agg, key) => (key[0] === '_' ? agg : { ...agg, [key]: values[key] }), {} as any)
